import React from "react";
import PropTypes from "prop-types";

import Component from "components/component";
import { formatUpchargeAmount } from "lib/helpers";

export default class DefaultOptionSelection extends Component {
  static propTypes = {
    optionName: PropTypes.string,
    selectionName: PropTypes.string,
    upchargeAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    thumbnailImage: PropTypes.string,
    displayUpchargeAmountOverride: PropTypes.string,
    displaySummaryFabricPrice: PropTypes.string,
    showQuantity: PropTypes.bool.isRequired,
    quantityCount: PropTypes.number.isRequired,
    isFabric: PropTypes.bool,
  };

  static defaultProps = {
    isFabric: false
  };

  render() {
    const {
      optionName,
      selectionName,
      upchargeAmount,
      thumbnailImage,
      displayUpchargeAmountOverride,
      displaySummaryFabricPrice,
      quantityCount,
      showQuantity,
      isFabric
    } = this.props;

    let amount = upchargeAmount;

    if (displayUpchargeAmountOverride) {
      amount = displayUpchargeAmountOverride;
    }

    let quantityDisplay = null;

    if (showQuantity) {
      quantityDisplay = `× ${quantityCount}`;
    }

    return (
      <div className="option-selection-wrapper">
        {thumbnailImage && (
          <img src={thumbnailImage} className="option-selection-img" />
        )}

        <p className="option-name">{optionName}</p>
        <p className="option-value">
          {selectionName} | {formatUpchargeAmount(amount)} {quantityDisplay}
          {isFabric && (
            <span>
              <br />
              {displaySummaryFabricPrice} {quantityDisplay}
            </span>
          )}
        </p>
      </div>
    );
  }
}
